import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { EDITOR_COLORS, editorText } from '../../../styles/editorTheme';

interface ClientsSubsectionPlaceholderViewProps {
  subsectionTitle: string;
}

export const ClientsSubsectionPlaceholderView: React.FC<ClientsSubsectionPlaceholderViewProps> = ({ subsectionTitle }) => {
  return (
    <View style={styles.panel}>
      <View style={styles.placeholderCard}>
        <Text style={styles.placeholderTitle}>{subsectionTitle}</Text>
        <Text style={styles.placeholderText}>
          This clients subsection is queued for shared migration.
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  panel: {
    padding: 20,
  },
  placeholderCard: {
    backgroundColor: EDITOR_COLORS.background,
    borderRadius: 12,
    padding: 20,
  },
  placeholderTitle: {
    ...editorText,
    color: EDITOR_COLORS.textPrimary,
    marginBottom: 8,
  },
  placeholderText: {
    ...editorText,
    color: EDITOR_COLORS.textMuted,
    lineHeight: 20,
  },
});
